'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var pathToPersons = ['one', action.pid];

  var pathToFeisParticipant = ['one', action.num];

  switch (action.type) {
    case 'GET_PERSON_START':
      return state.mergeIn(pathToPersons, (0, _immutable.fromJS)({ loading: true }));
    case 'GET_FEIS_PARTICIPANT_START':
      return state.setIn(pathToFeisParticipant, (0, _immutable.fromJS)({ loading: true }));
    case 'GET_RESULTS_START':
      return state.setIn(['comments', action.person_id, 'loading'], true);
    case 'GET_SCORES_START':
      return state.setIn(['scores', action.person_id, 'loading'], true);
    case 'GET_PERSON':
      return state.deleteIn(pathToPersons.concat(['loading'])).mergeIn(pathToPersons, (0, _immutable.fromJS)(action.payload));
    case 'GET_FEIS_PARTICIPANT':
      return state.setIn(['one', action.payload.id], (0, _immutable.fromJS)(action.payload)).deleteIn(pathToFeisParticipant);
    case 'GET_FEIS_PARTICIPANT_ERROR':
      return state.deleteIn(pathToFeisParticipant);
    case 'GET_STUDENTS':
      return action.payload.students.reduce(function (state, student) {
        return state.setIn(['one', student.id], (0, _immutable.fromJS)(student));
      }, state);
    case 'UPDATE_PERSON':
      return state.mergeIn(pathToPersons, action.account);
    case 'GET_RESULTS':
      return action.payload.reduce(function (state, data) {
        var newState = data.dresscheck && state.setIn(['dresscheck', action.person_id, data.event.id, data.adj.id], (0, _immutable.fromJS)(data.dresscheck.id)) || state;
        return data.comments && newState.setIn(['comments', action.person_id, data.event.id], newState.getIn(['comments', action.person_id, data.event.id]) && newState.getIn(['comments', action.person_id, data.event.id]).push((0, _immutable.fromJS)(data.comments.id)) || (0, _immutable.fromJS)([data.comments.id])) || newState;
      }, state).deleteIn(['comments', action.person_id, 'loading']);
    case 'GET_SCORES':
      return action.payload.reduce(function (state, data) {
        return state.setIn(['scores', action.person_id, data.event.id], state.getIn(['scores', action.person_id, data.event.id]) && state.getIn(['scores', action.person_id, data.event.id]).push((0, _immutable.fromJS)(data.score.id)) || (0, _immutable.fromJS)([data.score.id]));
      }, state).deleteIn(['scores', action.person_id, 'loading']);

    case 'GET_UNPAID_COMPETITORS_FOR_FEIS':
      return action.payload.reduce(function (state, competitor) {
        return state.mergeDeepIn(['one', competitor.id], (0, _immutable.fromJS)(competitor));
      }, state);

    case 'GET_UNPAID_ACCOUNTS_FOR_FEIS':
      return action.payload.reduce(function (state, a) {
        return state.mergeDeepIn(['one', a.id], (0, _immutable.fromJS)(a));
      }, state);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/persons/index.js
// module id = 705
// module chunks = 0